//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TooltipColumn',
  props: {
    label: { type: String, default: '' },
    name: { type: String, default: '' },
    limit: { type: Number, default: 20 },
    lines: { type: Number, default: 0 },
    width: { type: [String, Number], default: undefined },
    minWidth: { type: [String, Number], default: undefined },
  },
  data() {
    return {
      // 记录已确认溢出的行 index，用 Set 避免重复判断
      overflowSet: new Set(),
    };
  },
  methods: {
    checkOverflow(e, idx) {
      if (this.overflowSet.has(idx)) return;
      const el = e.currentTarget;
      // 临时去掉行数限制，测量真实高度
      el.style.webkitLineClamp = 'unset';
      const fullHeight = el.scrollHeight;
      el.style.webkitLineClamp = this.lines;
      const clampedHeight = el.clientHeight;
      if (fullHeight > clampedHeight) {
        // 触发响应式更新：重新赋值整个 Set
        const next = new Set(this.overflowSet);
        next.add(idx);
        this.overflowSet = next;
      }
    },
    showText(text) {
      const t = text || '';
      return t.length > this.limit ? t.slice(0, this.limit) : t;
    },
  },
};
